import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import BaseViewfrom from '../views/BaseView.vue';
import DetailView from '@/views/DetailView.vue';
import OrderDetailView from '@/views/OrderDetailView.vue';
import ScanView from '@/views/ScanView.vue';
import TestView from '@/views/TestView.vue';
import AboutView from '../views/AboutView.vue';
import AlipayResultView from '@/views/payment/AlipayResultView.vue';
import InvoiceView from '@/views/InvoiceView.vue';
import InvoiceManagementView from '@/views/InvoiceManagementView.vue';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: BaseViewfrom,
  // },
  {
    path: '/',
    name: 'Layout',
    redirect: '/home',
    component: () => import('../views/basic/LayoutView.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('../views/basic/HomeView.vue'),
      },
      {
        path: '/category',
        name: 'Category',
        component: () => import('../views/basic/CategoryView.vue'),
      },
      {
        path: '/cart',
        name: 'Cart',
        component: () => import('../views/basic/CartView.vue'),
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('../views/basic/OrderView.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/detail',
    name: 'detail',
    component: DetailView,
  },
  {
    path: '/order/:id',
    name: 'orderDetail',
    component: OrderDetailView,
  },
  {
    path: '/scan',
    name: 'scan',
    component: ScanView,
  },
  {
    path: '/test',
    name: 'test',
    component: TestView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
  {
    path: '/payment/alipay/result',
    name: 'alipayResult',
    component: AlipayResultView,
    meta: {
      title: '支付结果',
    },
  },
  {
    path: '/invoice/:id',
    name: 'invoice',
    component: InvoiceView,
  },
  {
    path: '/invoice',
    name: 'invoiceManagement',
    component: InvoiceManagementView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
